import React from 'react';
import { Button, Header, Icon, Responsive, Segment, Tab, Transition } from 'semantic-ui-react';
import axios from 'axios';
import PersonalInfo from './PersonalInfo';
import StudentLockForm from './StudentLockForm';
import PreviousCertificates from './PreviousCertificates';
import CurrentEducation from './CurrentEducation';
import MobilityList from './MobilityList';
import StudentCertificates from './StudentCertificates';
import StudentRole from './StudentRole';


export default class StudentOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentStatuses: null,
            studentStatusesLoadedWithErr: null,
            studentJMBG: '',
            student: JSON.parse(localStorage.getItem('student')),
            duration: 1000,
            visible: true,
            graduationVisibility: true,
            abandonmentVisibility: true,
            pauseVisibility: true,
            disciplinaryVisibility:true,
        };
        this.updateStudentStatuses = this.updateStudentStatuses.bind(this);
        this.fetchStudentStatus = this.fetchStudentStatus.bind(this);
        this.toggleLockedVisibility = this.toggleLockedVisibility.bind(this);
    }

    componentDidMount() {
        this.fetchStudentStatus();
    }

    fetchStudentStatus() {
        let { student } = this.state;
        axios.get(`students/statuses/${student.id}/`)
            .then(res => {
                this.setState({
                    studentStatuses: res.data,
                    locked: res.data.locked,
                    graduationDate: res.data.graduationDate,
                    dateOfAbandonment: res.data.dateOfAbandonment,
                    pauseSemester: res.data.pauseSemester,
                    disciplinaryMeasure: res.data.disciplinaryMeasure,
                    studyProgramStudentSwitchedToId: student.studyProgramStudentSwitchedToId

                });
                localStorage.setItem('studentStatuses', JSON.stringify(res.data));
            })
            .catch(err => {
                console.log('Failed to fetch student statuses.');
                this.setState({studentStatusesLoadedWithErr: true})
            });


    }

    updateStudentStatuses() {
        this.fetchStudentStatus();
    }

    toggleLockedVisibility = () =>
        this.setState((prevState) => ({ visible: !prevState.visible }));

    toggleGraduationVisibility = () =>
        this.setState((prevState) => ({ graduationVisibility: !prevState.graduationVisibility }));
    toggleAbandonmentVisibility = () =>
        this.setState((prevState) => ({ abandonmentVisibility: !prevState.abandonmentVisibility }));
    togglePauseVisibility = () =>
        this.setState((prevState) => ({ pauseVisibility: !prevState.pauseVisibility }));
    toggleDisciplinaryVisibility = () =>
        this.setState((prevState) => ({ disciplinaryVisibility: !prevState.disciplinaryVisibility }));

    render() {
        const { student, withdrawal } = this.state;
        let panes = [];
        if (this.props.location.pathname === '/upis-studenta/informacije-o-studentu') {
            panes = [
                {
                    // for professor
                    menuItem: 'Lični podaci',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <PersonalInfo
                            // student.studentId - personId
                            // student.id - ssp
                            studentId={student.studentId ? student.studentId : student.id}
                            ssp={ student.id}
                            studyProgramId={student.studyProgramId}
                            getJMBG={(studentJMBG) => this.setState({ studentJMBG })}
                            limitation={this.state.locked || this.state.dateOfAbandonment || this.state.studyProgramStudentSwitchedToId}
                        />
                    </Tab.Pane>)
                }];
        } else {
            panes = [
                {
                    menuItem: 'Lični podaci',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <PersonalInfo
                            studentId={student.studentId ? student.studentId : student.id}
                            ssp={ student.id}
                            studyProgramId={student.studyProgramId}
                            getJMBG={(studentJMBG) => this.setState({ studentJMBG })}
                            limitation={this.state.locked || this.state.dateOfAbandonment || this.state.studyProgramStudentSwitchedToId}
                        />
                    </Tab.Pane>)
                },
                {
                    menuItem: 'Tok studiranja',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <CurrentEducation
                            graduationDate={this.state.graduationDate}
                            student={student}
                            jmbg={this.state.studentJMBG}
                            locked={this.state.locked}
                            limitation={this.state.locked || (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' && this.state.dateOfAbandonment) || this.state.graduationDate  || this.state.studyProgramStudentSwitchedToId || this.state.pauseSemester || this.state.disciplinaryMeasure}
                            pauseSemester={this.state.pauseSemester}
                            disciplinaryMeasure={this.state.disciplinaryMeasure}
                            updateStudentStatuses={this.updateStudentStatuses}
                            toggleAbandonmentVisibility={this.toggleAbandonmentVisibility}
                            toggleDisciplinaryVisibility={this.toggleDisciplinaryVisibility}
                            toggleGraduationVisibility={this.toggleGraduationVisibility}
                            togglePauseVisibility={this.togglePauseVisibility}

                        />
                    </Tab.Pane>)
                },
                {
                    menuItem: 'Mobilnost',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <MobilityList
                            limitation={this.state.locked || this.state.dateOfAbandonment || this.state.studyProgramStudentSwitchedToId}
                            student={student}
                            studentStudyProgramId={student.id}
                        >

                        </MobilityList>
                    </Tab.Pane>)
                },
                !withdrawal ? {
                    menuItem: 'Podaci o završetku ciklusa studija',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <StudentLockForm
                            studentStudyProgramId={student.id}
                            studyProgramId={student.studyProgramId}
                            locked={this.state.locked}
                            limitation={this.state.locked || this.state.dateOfAbandonment || this.state.studyProgramStudentSwitchedToId }
                            graduationDate={this.state.graduationDate}
                            updateStudentStatuses={this.updateStudentStatuses}
                            toggleLockedVisibility={this.toggleLockedVisibility}
                            toggleGraduationVisibility={this.toggleGraduationVisibility}
                        />
                    </Tab.Pane>)
                } : null,

                {
                    menuItem: 'Dokumenti',
                    render: () => (<Tab.Pane attached={false} as={Responsive}>
                        <StudentCertificates
                            studentId={student.studentId}
                            studyProgramId={student.studyProgramId}
                            limitation={this.state.locked || this.state.studyProgramStudentSwitchedToId }
                        />
                    </Tab.Pane>)
                }

            ];
        }

        const { duration, visible,graduationVisibility, abandonmentVisibility, pauseVisibility, disciplinaryVisibility } = this.state;

        return (<div>
            <h1>Informacije o studentu</h1>
            <Segment.Group raised>
                <Segment>
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <Header as="h3">
                        {student.firstName} {student.lastName} - {student.index}

                        <span style={{ float: 'right', textAlign: 'center' }}>
                            <Transition
                                animation={'bounce'}
                                duration={duration}
                                visible={visible}
                            >
                                <Icon name="lock" color={this.state.locked ? 'blue' : 'grey'} />
                            </Transition>

                            <Header.Subheader>
                            &nbsp;Zaključan/a&nbsp;&nbsp;
                            </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>

                             <Transition
                                 animation={'bounce'}
                                 duration={duration}
                                 visible={graduationVisibility}
                             >
                                <Icon name="graduation" color={this.state.graduationDate ? 'green' : 'grey'} />
                            </Transition>

                            <Header.Subheader>
                            &nbsp;Diplomiran/a&nbsp;&nbsp;
                            </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>

                            <Transition
                                animation={'bounce'}
                                duration={duration}
                                visible={abandonmentVisibility}
                            >
                                <Icon name="sign-out" color={this.state.dateOfAbandonment ? 'red' : 'grey'} />
                            </Transition>
                            <Header.Subheader>
                            &nbsp;Ispisan/a&nbsp;&nbsp;
                            </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>
                        <Transition
                            animation={'bounce'}
                            duration={duration}
                            visible={pauseVisibility}
                        >
                                <Icon name="snowflake" color={this.state.pauseSemester ? 'blue' : 'grey'} />
                            </Transition>

                        <Header.Subheader>
                           &nbsp; Status mirovanja&nbsp;&nbsp;
                        </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>
                        <Transition
                            animation={'bounce'}
                            duration={duration}
                            visible={disciplinaryVisibility}
                        >
                               <Icon name="times circle outline" color={this.state.disciplinaryMeasure ? 'red' : 'grey'} />
                            </Transition>

                        <Header.Subheader>
                           &nbsp; Disciplinska mjera&nbsp;&nbsp;
                        </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>
                        <Transition
                            animation={'bounce'}
                            duration={duration}
                            visible={disciplinaryVisibility}
                        >
                               <Icon name="check" color={this.state.studyProgramStudentSwitchedToId ? 'blue' : 'grey'} />
                            </Transition>

                        <Header.Subheader>
                           &nbsp; Prešao/la na novi NPP&nbsp;&nbsp;
                        </Header.Subheader></span>
                        <span style={{ float: 'right', textAlign: 'center' }}>
                            <Icon
                                name="user"
                                color={!this.state.locked && !this.state.graduationDate
                                && !this.state.dateOfAbandonment && !this.state.disciplinaryMeasure
                                && !this.state.pauseSemester && !this.state.studyProgramStudentSwitchedToId ?
                                    'blue' : 'grey'}
                            />
                            <Header.Subheader>
                            &nbsp;Aktivan/na&nbsp;&nbsp;
                            </Header.Subheader>
                        </span>

                        <Header.Subheader>
                            Student/ica - index
                        </Header.Subheader>

                    </Header>
                </Segment>
                {this.state.studentStatusesLoadedWithErr ? <Segment textAlign={'center'}> <Button basic onClick={()=>window.location.reload()}>Učitaj ponovo</Button></Segment>:<Segment clearing><Tab id="myTab" menu={{
                    secondary: true,
                    pointing: true,
                    color: 'blue'
                }} panes={panes} defaultActiveIndex={0}/></Segment>}
            </Segment.Group>
        </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentOverview.js